// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderSkeleton_header__39Lxv content-flip"};